import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import "./Gate.scss";

import toaster from "toasted-notes";
import {changePaymentType, StoreOnlineGateWay} from "../Payment/PaymentService";
import {GetBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {useResp} from "../../hooks";
import GateWayResponsive from "../GateWayResponsive/GateWayResponsive";


function Success(props) {
    return (
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Error(props) {

    return (
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Gate() {
    const history = useHistory();
    const location = useLocation();

    const [invoice, set_invoice] = useState(false)
    const [selectedGate, set_selectedGate] = useState(null)
    const [paymentType, set_paymentType] = useState("online")
    const [merchant, set_merchant] = useState({})

    useEffect(() => {
        console.log("Location : ", location)
        if (location.state && location.state.create) {
            set_invoice(location.state.create)
        }
        getBasket()
    }, [])


    const getBasket = async () => {
        try {
            const response = await GetBasket();
            if (response.data.merchant) {
                set_merchant(response.data.merchant)
            }
        } catch (e) {
            // console.log(e)
        }
    }


    const createInvoice = async (obj) => {
        // try{
        //     const response = await StoreOnlineCreateInvoice(obj);
        //     return response.data
        // }catch (e) {
        //     // console.log(e)
        //     return false
        // }
    }

    const redirectToGateWay = async () => {
        console.log(selectedGate, invoice.sign)
        if (selectedGate && invoice && invoice.sign) {
            const res = await changePaymentType(invoice.res_num, "online")
            try {
                const response = await StoreOnlineGateWay(selectedGate, invoice.sign)
                console.log("go to gateway", response)
                document.location.href = response.data.url
            } catch (e) {
                console.log(e)
            }
        } else {
            toaster.notify(({onClose}) => (<Error message={"لطفا یک درگاه را انتخاب نمایید"}/>), {duration: 2000});
        }
    }

    const redirectForLocal = async () => {
        try {
            if (paymentType === "local") {
                const res = await changePaymentType(invoice.res_num, "physical")
                toaster.notify(({onClose}) => (<Error message={"از خرید شما متشکریم"}/>), {duration: 2000});
                history.push("/reward")
            }
        } catch (e) {
            console.log(e)
        }

    }

    const {height, width, mobileWidth} = useWindowDimensions();
    const resp = useResp()

    return (
        <>
            {resp ? <GateWayResponsive redirectForLocal={redirectForLocal} redirectToGateWay={redirectToGateWay}
                                       selectedGate={selectedGate} set_selectedGate={set_selectedGate}
                                       set_paymentType={set_paymentType} paymentType={paymentType}
                                       invoice={invoice}/> : null}
            {!resp ? <div className="online-sendinfo-container" style={{flexDirection: "column"}}>
                <div className="basket-brand">
                    <img src={merchant.thumbnail} alt=""/>
                </div>


                <div className="gate-cont">
                    <div className="gate-wr">
                        <div className="online-header-section"
                             style={{width: mobileWidth ? mobileWidth : document?.getElementById('mobile-sec')?.clientWidth}}>
                            <i className="fa fa-arrow-left"
                               onClick={() => {
                                   history.goBack()
                               }}
                            ></i>
                            <span>نوع پرداخت</span>
                        </div>

                        {/*<div className="ipg-section">*/}
                        {/*    <span>نوع پرداخت</span>*/}
                        {/*    <div className="ipg-pay-list">*/}
                        {/*        <div className="ipg-pay-item">*/}
                        {/*            <span>در محل</span>*/}
                        {/*            <input type="radio"*/}
                        {/*                   onClick={() => {*/}
                        {/*                       set_paymentType("local")*/}
                        {/*                   }}*/}
                        {/*                   checked={paymentType === "local"}*/}
                        {/*                   name="payType" id=""/>*/}
                        {/*        </div>*/}
                        {/*        <div className="ipg-pay-item">*/}
                        {/*            <span>آنلاین</span>*/}
                        {/*            <input*/}
                        {/*                onClick={() => {*/}
                        {/*                    set_paymentType("online")*/}
                        {/*                }}*/}
                        {/*                checked={paymentType === "online"}*/}
                        {/*                type="radio" name="payType" id=""/>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}

                        {/*</div>*/}


                        {paymentType === "online" ? <div className="ipg-section">
                            <div className="ipg-title">
                    <span>
                        لطفا یک درگاه را انتخاب نمایید
                    </span>
                            </div>
                            {invoice && invoice.ipg.map(item => {
                                return (
                                    <div className="ipg-item">
                                        <span>{item.persian_name}</span>
                                        <img src={item.icon} alt=""/>
                                        <input
                                            onClick={() => {
                                                set_selectedGate(item.name)
                                            }}
                                            checked={selectedGate === item.name}
                                            type="radio" name="ipg" id=""/>
                                    </div>
                                )
                            })}

                        </div> : null}
                    </div>
                </div>


                <div className="online-product-footer"
                     style={{width: mobileWidth ? mobileWidth : document?.getElementById('mobile-sec')?.clientWidth}}>
                    <div className="notAdded-mode">
                        {paymentType === "online" ? <div className="add-to-basket-btn" onClick={() => {
                            redirectToGateWay();
                        }}>
                            <span>پرداخت</span>
                        </div> : <div className="add-to-basket-btn" onClick={() => {
                            redirectForLocal();
                        }}>
                            <span>تایید نهایی</span>
                        </div>}

                    </div>
                </div>
                <div className="online-product-footer-md">
                    <div className="notAdded-mode-md">

                        {paymentType === "online" ?
                            <div className="add-to-basket-btn" onClick={() => {
                                redirectToGateWay();
                            }}>
                                <span>پرداخت</span>
                            </div> : <div className="add-to-basket-btn" onClick={() => {
                                redirectForLocal();
                            }}>
                                <span>تایید نهایی</span>
                            </div>}

                        <div className="add-to-basket-btn" onClick={() => {
                            history.goBack()
                        }}>
                            <span>برگشت</span>
                        </div>
                    </div>
                </div>
            </div> : null}


        </>
    )
}


export {Gate};

